//The docsData object contains the custom URL for the documentation site.
//The url is dynamically set while loading the system Themes data.
export const docsData = {
  url: "https://docs.spectrocloud.com",
};

export const DOC_LINK_MAPPING = {
  clusters: "/clusters/",
  "public-cloud": "/clusters/public-cloud/",
  "data-center": "/clusters/data-center/",
  edge: "/clusters/edge/",
  "cluster-management": "/clusters/cluster-management/",
  "deploy-cluster": "/clusters/public-cloud/deploy-k8s-cluster",
  "cluster-profiles": "/cluster-profiles/",
  terraform: "/terraform",
  "imported-clusters": "/clusters/imported-clusters/",
  "node-pool-repave":
    "/clusters/cluster-management/node-pool/#repave-behavior-and-configuration",
  "full-cluster-repave":
    "/clusters/cluster-management/node-pool/#repave-behavior-and-configuration",
  "default-resource-limits": "/user-management/palette-resource-limits/",
  repavement: "/glossary-all/#repavement",
  eks: "/clusters/public-cloud/aws/architecture/#aws-eks-architecture",
  "aws-eks": "/clusters/public-cloud/aws/eks/",
  "cluster-management-labels": "/clusters/cluster-management/node-labels",
  "cluster-management-taints": "/clusters/cluster-management/taints",
  "cluster-management-workloads":
    "https://docs.spectrocloud.com/integrations/packs/?pack=spectro-k8s-dashboard",
  "private-api-server-lb-settings":
    "https://docs.spectrocloud.com/clusters/public-cloud/azure/create-azure-cluster/#private-api-server-lb-settings",
  "add-helm-registry":
    "/registries-and-packs/helm-charts/#add-a-helm-chart-registry-to-palette",
  "edge-overlay": "/clusters/edge/networking/vxlan-overlay ",
  "kms-key": "/clusters/public-cloud/aws/enable-secrets-encryption-kms-key",
  "eks-cluster-endpoint":
    "https://docs.aws.amazon.com/eks/latest/userguide/cluster-endpoint.html",
  "aws-instance-types-and-pod-capacity":
    "/clusters/public-cloud/aws/architecture/#aws-instance-type-and-pod-capacity",
  "node-pool": "/clusters/cluster-management/node-pool",
  "fargate-profiles":
    "https://docs.aws.amazon.com/eks/latest/userguide/fargate.html",
  "cluster-profile-versioning":
    "/profiles/cluster-profiles/modify-cluster-profiles/version-cluster-profile/",
  "profile-variables":
    "/profiles/cluster-profiles/create-cluster-profiles/define-profile-variables",
  "backup-restore": "/clusters/cluster-management/backup-restore",
  "oidc-userinfo": "/user-management/saml-sso/palette-sso-with-okta",
  "two-node-control-plane": "/clusters/edge/architecture/two-node",
  "deprecated-vcluster-migration":
    "/clusters/palette-virtual-clusters/migrate-virtual-clusters",
  "remote-shell": "/clusters/edge/cluster-management/remote-shell",
  "aws-account-permissions":
    "/clusters/public-cloud/aws/#awscloudaccountpermissions",
  "audit-logs-permission-list": "/audit-logs/#permission-list",
  "backup-restore-backup-locations":
    "/clusters/cluster-management/backup-restore/#backup-locations",
  "aws-required-iam-policies":
    "/clusters/public-cloud/aws/required-iam-policies",
  "resource-quota": "/devx/manage-dev-engine/resource-quota/",
  "cloud-cost-usage-cost":
    "/clusters/cluster-management/cloud-cost/#usage-cost",
  "use-non-fips-addon-packs":
    "/vertex/system-management/enable-non-fips-settings/use-non-fips-addon-packs",
  "use-non-fips-features":
    "/vertex/system-management/enable-non-fips-settings/use-non-fips-features",
  "allow-cluster-import":
    "/vertex/system-management/enable-non-fips-settings/allow-cluster-import",
  "cluster-rbac": "/clusters/cluster-management/cluster-rbac",
  "cluster-template": "/cluster-templates",
  "maintenance-policy": "/cluster-templates/create-cluster-template-policies",
} as const;
